import PremiumFoldersEmptyState from './PremiumContentEmptyState';
import PremiumFoldersEmptyStateContainer from './PremiumContentEmptyState.container';

export default PremiumFoldersEmptyStateContainer(PremiumFoldersEmptyState);
